import { executeSearchConstants } from '../constants'

export const Search = (state = {}, action) => {
    switch (action.type) {
        case executeSearchConstants.SEARCH_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case executeSearchConstants.SEARCH_SUCCESS:
            return { loading: false, items: action.searchData, error: undefined }

        case executeSearchConstants.SEARCH_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const CustomCatalogData = (state = {}, action) => {
    switch (action.type) {
        case executeSearchConstants.SEARCH_AUTOCOMPLETE_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case executeSearchConstants.SEARCH_AUTOCOMPLETE_SUCCESS:
            return { loading: false, items: action.searchData, error: undefined }

        case executeSearchConstants.SEARCH_AUTOCOMPLETE_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}